var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.301,
    height: 18,
    viewBox: "0 0 18.301 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9993",
    "data-name": "Group 9993",
    transform: "translate(-3427.85 -12373)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18502",
    "data-name": "Path 18502",
    d: "M0,0H18V18H0Z",
    transform: "translate(3428 12373)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_7345139_postal_service_mailbox_postbox_zipcode_icon",
    "data-name": "7345139_postal_service_mailbox_postbox_zipcode_icon",
    transform: "translate(3426 12366)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18499",
    "data-name": "Path 18499",
    d: "M19.214,12.384A3.912,3.912,0,0,0,15.348,9H5.3a.294.294,0,0,0-.13.033,3.194,3.194,0,0,0-2.749,2.941L2,18.28a.3.3,0,0,0,.3.32H9.8v3.9a.3.3,0,0,0,.3.3h1.8a.3.3,0,0,0,.3-.3V18.6h7.5a.3.3,0,0,0,.3-.34ZM8.3,18H2.621l.4-5.986a2.586,2.586,0,0,1,5.16,0L8.579,18Zm3.3,4.2H10.4V18.6h1.2Zm.3-4.2H9.181l-.4-6.026A3.183,3.183,0,0,0,7.451,9.6h7.9a3.31,3.31,0,0,1,3.271,2.864L19.357,18Z",
    fill: "#919191",
    stroke: "#919191",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18500",
    "data-name": "Path 18500",
    d: "M9.7,26H7.3a.3.3,0,1,0,0,.6H9.7a.3.3,0,1,0,0-.6Z",
    transform: "translate(-3.5 -11.9)",
    fill: "#919191",
    stroke: "#919191",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18501",
    "data-name": "Path 18501",
    d: "M36.5,22H29.3a.3.3,0,0,0-.3.3v2.4a.3.3,0,0,0,.3.3h7.2a.3.3,0,0,0,.3-.3V22.3A.3.3,0,0,0,36.5,22Zm-.3,2.4H29.6V22.6h6.6Z",
    transform: "translate(-18.9 -9.1)",
    fill: "#919191",
    stroke: "#919191",
    strokeWidth: 0.3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZip);
export default __webpack_public_path__ + "static/media/zip.569a69c16d991a3354a08be0a459c537.svg";
export { ForwardRef as ReactComponent };